import PropTypes from 'prop-types';
import GlossaryText from '../GlossaryText';
import styles from './TableModule.module.scss';

const TableModule = ({
    data = [],
    firstRowIsTableHeader = false,
    firstColIsHeader = false,
    tableCaption = '',
}) => {
    if (!data.length) {
        return null;
    }

    const headerRow = firstRowIsTableHeader ? data[0] : null;
    const bodyRows = firstRowIsTableHeader ? data.slice(1) : data;

    return (
        // Focusable so an overflowing table can be scrolled from the keyboard.
        <div className={styles['TableModule']} tabIndex={0}>
            <table className={styles['TableModule__Table']}>
                {!!tableCaption && (
                    <caption className={styles['TableModule__Caption']}>
                        <GlossaryText text={tableCaption} />
                    </caption>
                )}
                {!!headerRow && (
                    <thead>
                        <tr>
                            {headerRow.map((cell, columnIndex) => (
                                <th key={columnIndex} scope="col">
                                    <GlossaryText text={cell} />
                                </th>
                            ))}
                        </tr>
                    </thead>
                )}
                <tbody>
                    {bodyRows.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {row.map((cell, columnIndex) => {
                                if (firstColIsHeader && columnIndex === 0) {
                                    return (
                                        <th
                                            key={columnIndex}
                                            scope="row"
                                            className={
                                                styles['TableModule__RowHeader']
                                            }>
                                            <GlossaryText text={cell} />
                                        </th>
                                    );
                                }

                                return (
                                    <td key={columnIndex}>
                                        <GlossaryText text={cell} />
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

TableModule.propTypes = {
    data: PropTypes.arrayOf(PropTypes.array),
    firstRowIsTableHeader: PropTypes.bool,
    firstColIsHeader: PropTypes.bool,
    tableCaption: PropTypes.string,
};

export default TableModule;
